import { Select, SelectField, type SelectFieldProps, type SelectProps } from '@nvision/ui';

import { useCarriers } from '../../hooks';
import type { Carrier, CarrierFilters } from '../../models';

export interface CarrierFieldProps extends Omit<SelectProps<Carrier>, 'options'> {
  defaultFilters?: Partial<CarrierFilters & { searchParams: { ids?: string[] } }>;
  label?: string;
  errorMessage?: SelectFieldProps<Carrier>['errorMessage'];
  isInvalid?: boolean;
}

export const CarrierField: React.FC<CarrierFieldProps> = ({ defaultFilters, label, ...otherFieldProps }) => {
  const { data, isLoading, updateFilters } = useCarriers(defaultFilters);

  if (label) {
    return (
      <SelectField
        {...otherFieldProps}
        label={label}
        placeholder="Start typing..."
        options={data?.list ?? []}
        onInputChange={(search) => updateFilters({ search: { carrierName: search } })}
        isLoading={isLoading}
      />
    );
  }

  return (
    <Select
      {...otherFieldProps}
      placeholder="Start typing..."
      options={data?.list ?? []}
      onInputChange={(search) => updateFilters({ search: { carrierName: search } })}
      isLoading={isLoading}
    />
  );
};
